import React from 'react';
import {
  SCHEDULE_PRESETS,
  minScheduleValue,
  scheduleTzLabel,
  validateScheduleValue,
} from '../../lib/scheduleSend';

export const GMAIL_SCHEDULE_NOTE = "For Gmail sends, use Gmail's own Schedule send.";

/** Date/time picker in Eastern Time with presets and the past / <2 min guard. */
export function ScheduleTimePicker({ value, onChange, disabled, compact = false }) {
  const check = validateScheduleValue(value);
  return (
    <div className={compact ? 'space-y-1.5' : 'space-y-2'}>
      <div className="flex flex-wrap items-center gap-1.5">
        <input
          type="datetime-local"
          value={value}
          min={minScheduleValue()}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
          aria-label="Send date and time (Eastern Time)"
          className={`border rounded-md px-2 py-1.5 text-sm outline-none focus:ring-2 focus:ring-primary focus:border-transparent ${
            check.error ? 'border-red-300' : 'border-gray-200'
          } ${compact ? 'w-full' : ''}`}
        />
        {SCHEDULE_PRESETS.map((p) => (
          <button
            key={p.id}
            type="button"
            disabled={disabled}
            onClick={() => onChange(p.value())}
            className="rounded-[100px] border border-gray-200 px-2.5 py-1 text-[11px] font-medium text-navy hover:bg-skyTint disabled:opacity-40"
          >
            {p.label}
          </button>
        ))}
      </div>
      <p className={`text-[11px] ${check.error ? 'text-red-600' : 'text-gray-500'}`}>
        {check.error || `Times are in ${scheduleTzLabel(check.iso)}.`}
      </p>
    </div>
  );
}

/** "Send now / Schedule" toggle for the Brevo send button, plus the picker in schedule mode. */
export default function ScheduleSendControl({
  mode,
  onModeChange,
  value,
  onValueChange,
  disabled,
  compact = false,
}) {
  const segment = (key, label) => (
    <button
      type="button"
      disabled={disabled}
      onClick={() => onModeChange(key)}
      aria-pressed={mode === key}
      className={`px-2.5 py-1 text-[11px] font-semibold rounded-md transition-colors disabled:opacity-40 ${
        mode === key ? 'bg-white text-navy shadow-sm' : 'text-gray-500 hover:text-navy'
      }`}
    >
      {label}
    </button>
  );

  return (
    <div className="space-y-2">
      <div className="inline-flex items-center gap-0.5 rounded-lg bg-ivory p-0.5 border border-gray-100">
        {segment('now', 'Send now')}
        {segment('schedule', 'Schedule')}
      </div>
      {mode === 'schedule' ? (
        <ScheduleTimePicker value={value} onChange={onValueChange} disabled={disabled} compact={compact} />
      ) : null}
    </div>
  );
}
